// extracted by mini-css-extract-plugin
export var active = "_7g-a";
export var activeIndicator = "_7g-9";
export var disabled = "_7g-b";
export var fullWidth = "_7g-2";
export var lg = "_7g-7";
export var md = "_7g-6";
export var redoButtonTabGroup = "_7g-0";
export var sm = "_7g-5";
export var tabButton = "_7g-4";
export var tabButtonsContainer = "_7g-1";
export var themeDestructive = "_7g-d";
export var themeNormal = "_7g-c";
export var themeSuccess = "_7g-e";
export var xl = "_7g-8";
export var xs = "_7g-3";